import { makeStyles } from '@material-ui/core/styles'
import { Grid } from '@mui/material'
import CoverageListItem from 'src/components/BuyPolicy/insuranceScreens/health/PlanDetails/CoverageListItem'

const CoveragesLists = ({ coverages, coverageTitle }) => {
  const classes = useStyles()

  return (
    <>
      {coverages?.length ? (
        <div className={classes.rootContainer}>
          <div>
            <span className={classes.topCoverageContent}>{coverageTitle}</span>
          </div>
          <Grid container className={classes.gridContainer}>
            {coverages?.map((coverageItem) => {
              return (
                <Grid
                  item
                  xs={12}
                  md={6}
                  lg={4}
                  key={`coverageItem_${coverageItem?.id}`}
                  justifyContent='center'
                  alignItems='stretch'
                >
                  <CoverageListItem coverageData={coverageItem} />
                </Grid>
              )
            })}
          </Grid>
        </div>
      ) : null}
    </>
  )
}
export default CoveragesLists
const useStyles = makeStyles({
  rootContainer: {
    display: 'flex',
    flexDirection: 'column',
    background: 'white',
    gap: '20px',
    padding: '20px 0',
  },
  topCoverageContent: {
    fontSize: '18px',
    fontWeight: 'bold',
    color: '#000000',
  },
  gridItem: {
    height: '100%',
    width: '100%',
  },
  noDataText: {
    fontSize: '18px',
    fontWeight: 'bold',
    color: 'rgba(0,0,0,.125)',
  },
})
